// import isotope
// import Isotope from 'isotope-layout';
// require('isotope-layout');

if($('.portfolio-search').length) {

    let iso = $('.portfolio-items').isotope({
        itemSelector: '.portfolio-item',
        layoutMode: 'fitRows',
    });

    iso.isotope({ filter: '.active' });

    let statusFilter = 'any',
        statusLabel = '',
        segmentFilter = 'any',
        segmentLabel = '',
        fundFilter = 'any',
        fundLabel = '';

    $('#portfolio-reset-button').on('click', function() {
        statusFilter = 'any';
        segmentFilter = 'any';
        fundFilter = 'any';
        checkStatusAnyOption();
        checkSegmentAnyOption();
        checkFundAnyOption();
        filterPortfolioItems();
    });

    function shouldShowReset() {
        if(statusFilter !== 'any' || segmentFilter !== 'any' || fundFilter !== 'any') {
            $('#portfolio-reset-button').addClass('showing');
        } else {
            $('#portfolio-reset-button').removeClass('showing');
        }
    }

    $('.status-dropdown-menu a').on('click', function(e) {
        e.preventDefault();
        statusFilter = $(this).data('status');
        statusLabel = $(this).text();
        checkStatusAnyOption();
        filterPortfolioItems();
        $('.status-dropdown').removeClass('active');
        $('.status-dropdown-menu').slideUp();
    });

    function checkStatusAnyOption() {
        if(statusFilter !== 'any') {
            $('.status-dropdown-any').removeClass('d-none');
            $('.status-dropdown .button-label').text(statusLabel);
        } else {
            $('.status-dropdown-any').addClass('d-none');
            $('.status-dropdown .button-label').text('Status');
        }
    }

    $('.segment-dropdown-menu a').on('click', function(e) {
        e.preventDefault();
        segmentFilter = $(this).data('segment');
        segmentLabel = $(this).text();
        filterPortfolioItems();
        checkSegmentAnyOption();
        $('.segment-dropdown').removeClass('active');
        $('.segment-dropdown-menu').slideUp();
    });

    function checkSegmentAnyOption() {
        if(segmentFilter !== 'any') {
            $('.segment-dropdown-any').removeClass('d-none');
            $('.segment-dropdown .button-label').text(segmentLabel);
        } else {
            $('.segment-dropdown-any').addClass('d-none');
            $('.segment-dropdown .button-label').text('Segment');
        }
    }

    $('.fund-dropdown-menu a').on('click', function(e) {
        e.preventDefault();
        fundFilter = $(this).data('fund');
        fundLabel = $(this).text();
        filterPortfolioItems();
        checkFundAnyOption();
        $('.fund-dropdown').removeClass('active');
        $('.fund-dropdown-menu').slideUp();
    });

    function checkFundAnyOption() {
        if(fundFilter !== 'any') {
            $('.fund-dropdown-any').removeClass('d-none');
            $('.fund-dropdown .button-label').text(fundLabel);
        } else {
            $('.fund-dropdown-any').addClass('d-none');
            $('.fund-dropdown .button-label').text('Fund');
        }
    }

    function filterPortfolioItems() {

        shouldShowReset();

        window.portfolio_items.forEach(function(item) {

            let matchesStatus = false,
                matchesSegment = false,
                matchesFund = false;

            if(statusFilter === 'any' || item.status === statusFilter) {
                matchesStatus = true;
            }

            if(segmentFilter === 'any') {
                matchesSegment = true;
            } else {
                item.segment.forEach(function(segment) {
                    if(segment.slug === segmentFilter) {
                        matchesSegment = true;
                    }
                });
            }

            if(fundFilter === 'any') {
                matchesFund = true;
            } else {
                if(item.fund) {
                    item.fund.forEach(function(fund) {
                        if(fund.slug === fundFilter) {
                            matchesFund = true;
                        }
                    });
                }
            }

            if(matchesStatus && matchesSegment && matchesFund) {
                // $('.portfolio-item-' + item.id).removeClass('d-none');
                $('.portfolio-item-' + item.id).addClass('active');
            } else {
                // $('.portfolio-item-' + item.id).addClass('d-none');
                $('.portfolio-item-' + item.id).removeClass('active');
            }

            iso.isotope({ filter: '.active' });

        });

    }

}
